import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import commonEn from './locales/en/common.json'
import customersEn from './locales/en/customers.json'
import customerCommunicationPreferencesEn from './locales/en/customerCommunicationPreferences.json'
import dashboardEn from './locales/en/dashboard.json'
import symbolsEn from './locales/en/symbols.json'
import templatesEn from './locales/en/templates.json'
import tradingStrategiesEn from './locales/en/tradingStrategies.json'
import customerPartnerOffersEn from './locales/en/customerPartnerOffers.json'
import customerLegalDocumentsEn from './locales/en/customerLegalDocuments.json'
import customerTradingStrategySubscriptionsEn from './locales/en/customerTradingStrategySubscriptions.json'
import basketsEn from './locales/en/baskets.json'
import portfoliosEn from './locales/en/portfolios.json'
import webhooksEn from './locales/en/webhooks.json'
import incomingSignalsEn from './locales/en/incomingSignals.json'
import strategyDataAlertsEn from './locales/en/strategyDataAlerts.json'
import infoAlertsEn from './locales/en/infoAlerts.json'
import unknownAlertsEn from './locales/en/unknownAlerts.json'
import emailNotificationsEn from './locales/en/emailNotifications.json'
import devtoolsEn from './locales/en/devtools.json'
import outstandingActionsDigestEn from './locales/en/outstandingActionsDigest.json'
import marketCandlesEn from './locales/en/marketCandles.json'
import processesEn from './locales/en/processes.json'
import customerFeedbackEn from './locales/en/customerFeedback.json'
import strategyRequestsEn from './locales/en/strategyRequests.json'
import offersEn from './locales/en/offers.json'
import customerOfferGrantsEn from './locales/en/customerOfferGrants.json'
import customerMembershipsEn from './locales/en/customerMemberships.json'
import membershipsEn from './locales/en/memberships.json'
import membershipTiersEn from './locales/en/membershipTiers.json'
import membershipRequestsEn from './locales/en/membershipRequests.json'
import addOnsEn from './locales/en/addOns.json'
import customerAddOnsEn from './locales/en/customerAddOns.json'
import accessToGrantEn from './locales/en/accessToGrant.json'
import accessToRemoveEn from './locales/en/accessToRemove.json'
import portfolioBuilderEn from './locales/en/portfolioBuilder.json'
import portfolioTrackerEn from './locales/en/portfolioTracker.json'

const resources = {
  en: {
    common: commonEn,
    customers: customersEn,
    customerCommunicationPreferences: customerCommunicationPreferencesEn,
    dashboard: dashboardEn,
    symbols: symbolsEn,
    templates: templatesEn,
    tradingStrategies: tradingStrategiesEn,
    customerPartnerOffers: customerPartnerOffersEn,
    customerLegalDocuments: customerLegalDocumentsEn,
    customerFeedback: customerFeedbackEn,
    strategyRequests: strategyRequestsEn,
    customerTradingStrategySubscriptions: customerTradingStrategySubscriptionsEn,
    baskets: basketsEn,
    portfolios: portfoliosEn,
    webhooks: webhooksEn,
    incomingSignals: incomingSignalsEn,
    strategyDataAlerts: strategyDataAlertsEn,
    infoAlerts: infoAlertsEn,
    unknownAlerts: unknownAlertsEn,
    emailNotifications: emailNotificationsEn,
    devtools: devtoolsEn,
    outstandingActionsDigest: outstandingActionsDigestEn,
    marketCandles: marketCandlesEn,
    processes: processesEn,
    offers: offersEn,
    customerOfferGrants: customerOfferGrantsEn,
    customerMemberships: customerMembershipsEn,
    memberships: membershipsEn,
    membershipTiers: membershipTiersEn,
    membershipRequests: membershipRequestsEn,
    addOns: addOnsEn,
    customerAddOns: customerAddOnsEn,
    accessToGrant: accessToGrantEn,
    accessToRemove: accessToRemoveEn,
    portfolioBuilder: portfolioBuilderEn,
    portfolioTracker: portfolioTrackerEn,
  },
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    defaultNS: 'common',
    ns: ['common', 'customers', 'dashboard', 'symbols', 'templates', 'tradingStrategies', 'customerTradingStrategySubscriptions', 'customerPartnerOffers', 'customerCommunicationPreferences', 'customerLegalDocuments', 'baskets', 'portfolios', 'webhooks', 'incomingSignals', 'strategyDataAlerts', 'infoAlerts', 'unknownAlerts', 'emailNotifications', 'devtools', 'outstandingActionsDigest', 'marketCandles', 'processes', 'customerFeedback', 'strategyRequests', 'offers', 'customerOfferGrants', 'customerMemberships', 'memberships', 'membershipTiers', 'membershipRequests', 'addOns', 'customerAddOns', 'accessToGrant', 'accessToRemove', 'portfolioBuilder', 'portfolioTracker'],
    interpolation: {
      escapeValue: false,
    },
  })

export default i18n
